var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.742,
    height: 44.366,
    viewBox: "0 0 84.742 44.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path_25",
    "data-name": "path 25",
    d: "M324.655,1363.606c-11.366.076-20.612,1.414-31.429,7.677-9.169,5.308-12.364,19.533,2.825,25.3,13.6,5.161,29,5.4,33.112,5.215,0,0,.913,3.31-6.7,6a25.371,25.371,0,0,0,11.325-1.253,16.631,16.631,0,0,0,7.372-5.65s4.368.8,15.69-2.744c14.168-4.435,17.7-17.758,7.69-24.986C353.148,1364.939,337.748,1363.517,324.655,1363.606Z",
    transform: "translate(-285.504 -1363.602)",
    fill: "#d13f06"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.7abc97851b81cd1f5de6bdd59b604bad.svg";
export { ForwardRef as ReactComponent };